import { Link } from "react-router-dom";

import { useLanguage } from "@/i18n/LanguageContext";

const PASSI_URL = "https://passi.fingletek.com/";

type Callout = {
  top: string;
  left: string;
  label: string;
  side?: "left" | "right";
};

type Step = {
  image?: string;
  title: string;
  body: string;
  callout?: Callout;
};

export function PassiGuidePage() {
  const { t } = useLanguage();
  const g = t.passiGuide;

  const steps: Step[] = [
    {
      image: "/branding/passi-guide/step-01-home.png",
      title: g.step1Title,
      body: g.step1Body,
      callout: { top: "58%", left: "18%", label: g.step1Callout, side: "right" },
    },
    {
      image: "/branding/passi-guide/step-02-templates.png",
      title: g.step2Title,
      body: g.step2Body,
    },
    {
      image: "/branding/passi-guide/step-03-generic-focus.png",
      title: g.step3Title,
      body: g.step3Body,
      callout: { top: "78%", left: "22%", label: g.step3Callout, side: "right" },
    },
    {
      image: "/branding/passi-guide/step-04-source.png",
      title: g.step4Title,
      body: g.step4Body,
      callout: { top: "48%", left: "28%", label: g.step4Callout, side: "right" },
    },
    {
      image: "/branding/passi-guide/step-05-confirm.png",
      title: g.step5Title,
      body: g.step5Body,
      callout: { top: "72%", left: "50%", label: g.step5Callout, side: "left" },
    },
    {
      image: "/branding/passi-guide/step-06-edit.png",
      title: g.step6Title,
      body: g.step6Body,
      callout: { top: "82%", left: "55%", label: g.step6Callout, side: "left" },
    },
    {
      image: "/branding/passi-guide/step-07-final.png",
      title: g.step7Title,
      body: g.step7Body,
    },
    {
      image: "/branding/passi-guide/step-08-stage-focus.png",
      title: g.step8Title,
      body: g.step8Body,
      callout: { top: "62%", left: "42%", label: g.step8Callout, side: "left" },
    },
    {
      image: "/branding/passi-guide/step-09-confirm-upload.png",
      title: g.step9Title,
      body: g.step9Body,
      callout: { top: "78%", left: "28%", label: g.step9Callout, side: "right" },
    },
    {
      image: "/branding/passi-guide/step-10-code-focus.png",
      title: g.step10Title,
      body: g.step10Body,
      callout: { top: "38%", left: "35%", label: g.step10Callout, side: "right" },
    },
    {
      image: "/branding/passi-guide/step-10-code-focus.png",
      title: g.step11Title,
      body: g.step11Body,
      callout: { top: "38%", left: "68%", label: g.step11Callout, side: "left" },
    },
    {
      title: g.step12Title,
      body: g.step12Body,
    },
  ];

  return (
    <div className="dn-section dn-passi-guide">
      <div className="dn-passi-guide-hero">
        <p className="eyebrow">{g.eyebrow}</p>
        <h1>{g.title}</h1>
        <p className="lead">{g.intro}</p>
        <p className="dn-passi-guide-optional">{g.optionalNote}</p>
        <div className="dn-cta-row">
          <a className="dn-btn dn-btn-primary" href={PASSI_URL} target="_blank" rel="noopener noreferrer">
            {g.openPassi}
          </a>
          <Link className="dn-btn dn-btn-ghost" to="/register">
            {g.returnRegister}
          </Link>
        </div>
        <p className="dn-passi-guide-warning">{g.copyCodeNotSecret}</p>
      </div>

      <ol className="dn-passi-guide-steps">
        {steps.map((step, index) => (
          <li key={`${step.title}-${index}`} className="dn-passi-guide-step">
            <div className="dn-passi-guide-step-copy">
              <span className="dn-passi-guide-step-num" aria-hidden="true">
                {index + 1}
              </span>
              <div>
                <h2>{step.title}</h2>
                <p>{step.body}</p>
              </div>
            </div>
            {step.image ? (
              <figure className="dn-passi-guide-figure">
                <img src={step.image} alt={step.title} loading="lazy" />
                {step.callout ? (
                  <div
                    className={`dn-passi-callout dn-passi-callout-${step.callout.side ?? "right"}`}
                    style={{ top: step.callout.top, left: step.callout.left }}
                  >
                    <span className="dn-passi-callout-dot" aria-hidden="true" />
                    <span className="dn-passi-callout-arrow" aria-hidden="true" />
                    <span className="dn-passi-callout-label">{step.callout.label}</span>
                  </div>
                ) : null}
              </figure>
            ) : null}
          </li>
        ))}
      </ol>

      <div className="dn-passi-guide-footer-cta">
        <a className="dn-btn dn-btn-primary" href={PASSI_URL} target="_blank" rel="noopener noreferrer">
          {g.openPassi}
        </a>
        <Link className="dn-btn dn-btn-gold" to="/register">
          {g.returnRegister}
        </Link>
      </div>
    </div>
  );
}
